(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.LocationController = (function(superClass) {
    extend(LocationController, superClass);

    function LocationController(scope, transitions, state, location) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.location = location;
      this.scope.repo = this.location;
      this.geocoder = App.load('core::Geocoder');
      $('.leaflet-control-container').show();
      $('.leaflet-control-buttongrid').hide();
      this.scope.transitionTo = (function(_this) {
        return function(state_name) {
          return _this.state.go(state_name);
        };
      })(this);
      this.scope.search = (function(_this) {
        return function() {
          return _this.geocoder.geocode(_this.location["new"].address);
        };
      })(this);
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          if ($transition.to().name !== 'grower.buyerlocation.place') {
            if (_this.location.feature_group != null) {
              App.map.removeLayer(_this.location.feature_group);
            }
            return setTimeout(function() {
              return App.map.removeControl(_this.location.drawControl);
            }, 100);
          }
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.transitionStart();
        };
      })(this));
    }

    return LocationController;

  })(Controller);

}).call(this);
